(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('event-dashboard', {
            parent: 'entity',
            url: '/event-dashboard?page&sort',
            data: {
                authenticate: true,
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'Tableaux de bord événement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-dashboard/event-dashboards.html',
                    controller: 'EventDashboardController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'displayOrder,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('event-dashboard.new', {
            parent: 'event-dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$state', '$uibModal', function($state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-dashboard/event-dashboard-dialog.html',
                    controller: 'EventDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                label: null,
                                description: null,
                                categoryIds: null,
                                subCategoryIds: null,
                                configJson: null,
                                showInNavbar: true,
                                active: true,
                                displayOrder: 0,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('event-dashboard', null, { reload: true });
                }, function() {
                    $state.go('event-dashboard');
                });
            }]
        })
        .state('event-dashboard.edit', {
            parent: 'event-dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SUPER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/event-dashboard/event-dashboard-dialog.html',
                    controller: 'EventDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EventDashboard', function(EventDashboard) {
                            return EventDashboard.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('event-dashboard', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('event-dashboard-view', {
            parent: 'entity',
            url: '/event-dashboard-view/{id}',
            data: {
                authenticate: true,
                authorities: ['ROLE_ADMIN','ROLE_EVT_EDIT','ROLE_EVT_READ_ONLY'],
                pageTitle: 'Tableau de bord événement'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/event-dashboard/event-dashboard-view.html',
                    controller: 'EventDashboardViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
